package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "id")
val IdStrings = Strings(
    analyzer = "Penganalisis",
    appreciationOverview = "Ikhtisar Apresiasi",
    chartLegendInterest = "Bunga",
    chartLegendPrincipal = "Pokok",
    chartXaxisMonths = "Bulan",
    chartYaxisPayment = "Pembayaran",
    code = "id",
    costOfCredit = "Biaya Kredit",
    creditDealAnalyzerDescription = "Masukkan detail pinjaman Anda untuk menerima analisis komprehensif tentang kesepakatan kredit Anda. Penganalisis kami mengevaluasi metrik utama untuk membantu Anda memahami biaya sebenarnya dari pinjaman Anda và membuat keputusan yang tepat.",
    detailsGoodRateLongTerm = "Suku bunga bagus tetapi jangka waktu panjang menghasilkan total biaya tinggi.",
    detailsHighApr = "APR tinggi. ",
    detailsHighInterestCost = "Total biaya bunga tinggi.",
    detailsHighRateShortTerm = "Suku bunga tinggi tetapi jangka waktu pendek menjaga total biaya tetap rendah.",
    detailsLowApr = "APR rendah. ",
    detailsLowInterestCost = "Total biaya bunga rendah.",
    discountsTradeIn = "Diskon / Tukar Tambah",
    displayName = "Bahasa Indonesia",
    distribution = "Distribusi",
    downPayment = "Uang Muka",
    effectiveApr = "APR",
    headerBalance = "Saldo",
    headerDate = "Tanggal",
    headerInterest = "Bunga",
    headerMonth = "#",
    headerPayment = "Pembayaran",
    headerPrincipal = "Pokok",
    hideDetails = "Sembunyikan Detail",
    interest = "Bunga",
    invalidData = "Data Tidak Valid",
    loanAmountSupportingText = "Total jumlah pinjaman, termasuk biaya tambahan apa pun.",
    loanDetails = "Detail Pinjaman",
    paymentSupportingText = "Estimasi pembayaran bulanan Anda.",
    paymentComposition = "Komposisi Pembayaran",
    percentSymbol = "%",
    principal = "Pokok",
    ratingBad = "Kesepakatan Buruk",
    ratingExcellent = "Kesepakatan Sangat Bagus",
    ratingFair = "Kesepakatan Wajar",
    ratingGood = "Kesepakatan Bagus",
    ratingPoor = "Kesepakatan Kurang Bagus",
    schedule = "Jadwal",
    showDetails = "Tampilkan Detail",
    summaryBad = "Sangat tidak menguntungkan, hindari jika memungkinkan.",
    summaryExcellent = "Kondisi keuangan yang sangat baik.",
    summaryFair = "Kondisi wajar, pertimbangkan untuk bernegosiasi.",
    summaryGood = "Kondisi bagus, standar untuk pasar.",
    summaryPoor = "Kondisi buruk, biaya atau suku bunga tinggi.",
    totalPaid = "Total Dibayar",
    lockTaxRate = "Kunci Tarif Pajak",
    unlockTaxRate = "Buka Kunci Tarif Pajak",
    currencySymbol = "Rp",
    currency = "Mata Uang",
    totalCreditAmount = "Total Jumlah Kredit",
    taxAmount = "Jumlah Pajak/Potongan",
    netAmountDisbursed = "Jumlah Bersih Dicairkan",
    years = "Tahun",
    loanTermTotalMonths = "Jangka Waktu Pinjaman (Bulan)",
    monthlyInstallment = "Angsuran Bulanan",
    principalInstallment = "Angsuran Pokok",
    otherFees = "Biaya Lainnya",
    insuranceCost = "Premi Asuransi",
    aprc = "Tingkat Persentase Tahunan Biaya (APRC)",
    totalAmountPayable = "Total Jumlah yang Harus Dibayar",
    prepaidFeeFixed = "Biaya Pemrosesan (Jumlah Tetap)",
    prepaidFeePercentage = "Biaya Pemrosesan (Persentase)",
    months = "Bulan",
    description = "Penganalisis ini membantu Anda mengevaluasi apakah penawaran pinjaman menguntungkan bagi Anda. Tidak seperti kalkulator standar, ini tidak memerlukan input suku bunga. Sebaliknya, ini menghitung APR và total biaya kredit berdasarkan pembayaran và biaya, memberikan peringkat kesepakatan và grafik terperinci.",
    agree = "Setuju",
    information = "Informasi",
    errorCalculationOverflow = "APR terlalu tinggi, luapan perhitungan.",
    errorTotalPaymentIsLessThanLoanAmount = "Jumlah yang diterima lebih kecil dari jumlah pinjaman.",
    errorDivisionByZero = "Pembagian dengan nol",
    errorNegativeResult = "Hasil negatif",
    errorRateTooHigh = "Suku bunga terlalu tinggi",
    errorCalculation = "Silakan masukkan data yang benar",
    close = "Tutup",

    hi = "Halo",
    guest = "Tamu",
    account = "Akun",
    signInWithGoogle = "Masuk dengan Google",
    signOut = "Keluar",
    settings = "Pengaturan",
    about = "Tentang",
    privacyPolicy = "Kebijakan Privasi",
    termsOfService = "Ketentuan Layanan",
    language = "Bahasa",

    theme = "Tema",
    light = "Terang",
    dark = "Gelap",
    system = "Sistem",
    toggleExpand = "Perluas/Ciutkan",
)
